import { unparse as convertToCSV } from 'papaparse/papaparse.min';
import { downloadCSV } from 'react-admin';

export const exporter = (data) => {
  const csv = convertToCSV({data})
  const BOM = '\uFEFF'
  downloadCSV(`${BOM} ${csv}`, 'export')
}